import React from "react";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { ContentItemBladeSchema } from "../../../schemas/blades/ContentItem";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { BladeContent } from "../../../components/BladeContent";
import { z } from "zod";
import { BladeHeaderCentered } from "../../../molecules/BladeHeaderCentered";
import { Media } from "../../../components/Media";
import { AspectRatio } from "../../../components/AspectRatio";
import { getMediaAspectRatio } from "../../../functional/getMediaAspectRatio";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { ArticleCoveredCard } from "../../../molecules/ArticleCoveredCard";
export const LandingMediaEmbedContractSchema = ContentItemBladeSchema.extend({
    type: z.literal("landingMediaEmbed"),
});
const _LandingMediaEmbed = ({ backdrop, header, content, className, ...bladeProps }) => {
    const headerContent = hasVisibleContent(header);
    const { media, action } = content;
    const { background, foreground } = backdrop || {};
    return (React.createElement(Blade, { "data-testid": "LandingMediaEmbedBlade", className: className, ...bladeProps },
        backdrop && (React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, background && React.createElement(Media, { "data-testid": "backdrop-embed-video", optimized: true, autoPlay: true, media: background })),
            React.createElement(BackdropForeground, null, foreground && React.createElement(Media, { "data-testid": "backdrop-foreground-image", media: foreground, role: "presentation" })))),
        React.createElement(BladeContent, { width: "large" },
            headerContent && React.createElement(BladeHeaderCentered, { ...header }),
            action ? (React.createElement(ArticleCoveredCard, { content: content, ...bladeProps })) : (React.createElement(AspectRatio, { ratio: getMediaAspectRatio(media, 16 / 9), "data-testid": "mediaAspectRatio" },
                React.createElement(Media, { "data-testid": `landing-media-embed-${media.type}`, autoPlay: false, controls: true, media: media }))))));
};
export const LandingMediaEmbed = styled(_LandingMediaEmbed) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=LandingMediaEmbed.js.map